import axios from "axios";
const PATH = "api:///v1/component-grants";
const list = () => axios({
    method: "GET",
    url: PATH,
});
const grant = (request) => axios({
    method: "POST",
    url: PATH,
    data: JSON.stringify(request),
    headers: {
        "Content-Type": "application/json",
    },
});
const grantAll = () => axios({
    method: "POST",
    url: `${PATH}/all`,
    headers: {
        "Content-Type": "application/json",
    },
});
const revoke = (grantId) => axios({
    method: "DELETE",
    url: `${PATH}/${grantId}`,
});
const listGranters = () => axios({
    method: "GET",
    url: `${PATH}/granters`,
});
export default {
    list,
    grant,
    grantAll,
    revoke,
    listGranters,
};
